import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface ProgressBarProps {
  title: string
  startTime: number | null
  durationMs: number | null
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  title,
  startTime,
  durationMs,
}) => {
  const start = startTime && durationMs ? new Date(startTime) : null
  const { t } = useTranslation()
  const [progress, setProgress] = useState(0)
  const [isCompleted, setIsCompleted] = useState(false)

  const estimatedEndTime = useMemo(() => {
    if (!start) return null
    if (!durationMs) return null
    return new Date(start.getTime() + durationMs)
  }, [start, durationMs])

  useEffect(() => {
    if (!startTime || !durationMs) return

    const updateProgress = () => {
      if (!start) return null
      const now = Date.now()
      const elapsedMs = Math.max(0, Math.min(now - start.getTime(), durationMs))
      const p = (elapsedMs / durationMs) * 100

      setProgress(p)

      if (elapsedMs >= durationMs) {
        setProgress(100)
        setIsCompleted(true)
      }
    }

    updateProgress()
    const timer = setInterval(updateProgress, 1000)
    return () => clearInterval(timer)
  }, [startTime, durationMs])

  const formattedEnd = estimatedEndTime
    ? estimatedEndTime.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null

  return (
    <div className="progress-with-timer">
      <div className="progress-header">
        <span className="progress-title">{title}</span>

        {progress > 0 && (
          <span className="progress-percentage">
            {t('Фотографии скачаны')}: {progress.toFixed(0)}%
          </span>
        )}
      </div>

      <div className="progress-bar-wrapper">
        <div
          className="progress-bar"
          style={{ width: `${Math.min(100, progress)}%` }}
        />
      </div>

      {formattedEnd && !isCompleted && (
        <div className="progress-footer">
          <span className="finish-time">
            ~ {t('Завершится')} {formattedEnd}
          </span>
        </div>
      )}
    </div>
  )
}
